<template>
<div class="chapter">
<div class="inner_page">
<div class="copyright" id="cop">
<p class="crt"><span class="big2">Copyright</span></p>
<p class="crt1">In the Balance<br/>Speeches 1949 &amp; 1950<br/>First published in 1951. Speeches © Estate of Winston S. Churchill<br/>Cover art to the electronic edition copyright © 2014 by RosettaBooks, LLC.</p>
<p class="crt1">All rights reserved. No part of this book may be used or reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer who may quote brief passages in a review.</p>
<p class="crt1">Image of Winston Churchill at the Declaration of the Poll at Woodford, 1951 reproduced by permission of Curtis Brown, London, on behalf of The Broadwater Collection, an archive of photographs owned by the Churchill family and held at the Churchill Archives Centre, Cambridge.</p>
<p class="crt1">Electronic edition published 2014 by RosettaBooks, LLC, New York.<br/>Cover jacket design by Alexia Garaventa<br/>ISBN e-Pub edition: 9780795329326</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795329326_epub_cop_r1.vue?60323af6